export default class ExpertisesAreas {

    constructor() {
        console.log('[ExpertisesAreas] init');

        this.page = document.querySelector('.page-expertises-areas');
        if (!this.page) return;

        // elementos
        this.searchInput = this.page.querySelector('#s');
        this.searchForm = this.page.querySelector('.formFilterSearch');
        this.clearButton = this.searchForm?.querySelector('.search-clear');
        this.emptyMessage = this.page.querySelector('.search-empty');
        this.select = this.page.querySelector('#expertise_area');

        // blocos por tipo
        this.listTypes = Array.from(this.page.querySelectorAll('.listType'));

        console.log('[ExpertisesAreas] listTypes found:', this.listTypes.length);

        this.ready();
    }

    ready() {
        this.bindSearch();
        this.bindSelect();
    }

    /* =====================================================
     * SEARCH (botão Buscar)
     * ===================================================== */
    bindSearch() {
        if (!this.searchForm || !this.searchInput) return;

        this.searchInput.addEventListener('input', () => {
            this.searchInput.setCustomValidity('');
            this.toggleClearButton(this.searchInput.value.length > 0);
        });

        this.clearButton?.addEventListener('click', () => {
            this.searchInput.value = '';
            this.searchInput.setCustomValidity('');
            if (this.select) this.select.value = '';
            this.toggleClearButton(false);
            this.resetAll();
            this.searchInput.focus();
        });

        this.searchForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const term = this.searchInput.value.toLowerCase().trim();
            console.log('[ExpertisesAreas] search:', term);

            if (term.length < 3) {
                this.searchInput.setCustomValidity(this.searchForm.dataset.minLengthMessage);
                this.searchInput.reportValidity();
                return;
            }

            this.searchInput.setCustomValidity('');

            let foundAny = false;

            this.listTypes.forEach((listType) => {
                const items = listType.querySelectorAll('[data-expertise-item]');
                let hasMatchInType = false;

                items.forEach((item) => {
                    const text = item.innerText.toLowerCase();
                    const match = text.includes(term);

                    item.classList.toggle('hidden', !match);

                    if (match) {
                        hasMatchInType = true;
                        foundAny = true;
                    }
                });

                // esconde o bloco inteiro se nenhum item bateu
                listType.classList.toggle('hidden', !hasMatchInType);
            });

            this.emptyMessage?.classList.toggle('hidden', foundAny);
        });
    }

    /* =====================================================
     * SELECT (troca imediata)
     * ===================================================== */
    bindSelect() {
        if (!this.select) return;

        this.select.addEventListener('change', () => {
            const selectedSlug = this.select.value;
            console.log('[ExpertisesAreas] select change:', selectedSlug);

            // limpa busca ao trocar select
            if (this.searchInput) {
                this.searchInput.value = '';
                this.searchInput.setCustomValidity('');
            }
            this.toggleClearButton(false);
            this.emptyMessage?.classList.add('hidden');

            // mostrar tudo
            if (!selectedSlug) {
                this.resetAll();
                return;
            }

            this.listTypes.forEach((listType) => {
                const typeSlug = listType.dataset.typeSlug;
                const match = typeSlug === selectedSlug;

                listType.classList.toggle('hidden', !match);

                // garante que itens internos fiquem visíveis
                if (match) {
                    listType
                        .querySelectorAll('[data-expertise-item]')
                        .forEach((item) => item.classList.remove('hidden'));
                }
            });
        });
    }

    /* =====================================================
     * Helpers
     * ===================================================== */
    resetAll() {
        console.log('[ExpertisesAreas] reset all');

        this.listTypes.forEach((listType) => {
            listType.classList.remove('hidden');

            listType
                .querySelectorAll('[data-expertise-item]')
                .forEach((item) => item.classList.remove('hidden'));
        });

        this.emptyMessage?.classList.add('hidden');
    }

    toggleClearButton(show) {
        this.clearButton?.classList.toggle('hidden', !show);
        this.clearButton?.classList.toggle('flex', show);
        this.searchInput?.classList.toggle('pr-10', show);
        this.searchInput?.classList.toggle('pr-2', !show);
    }
}

/* =====================================================
 * Init
 * ===================================================== */
if (document.querySelector('.page-expertises-areas')) {
    new ExpertisesAreas();
}
